import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateActivationWindow = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const updateActivationWindow = async ({ activationWindowStart, activationWindowEnd, assignappId }) => {
    startLoading();
    const response = await apiPatch(`/assignapps/${assignappId}/update_activation_window`, "Error al actualizar la ventana de tiempo", {
      activation_window_start: activationWindowStart,
      activation_window_end: activationWindowEnd,
    });
    setResponse(response);

    return !response?.error;
  };

  return { updateActivationWindow, error };
};

export default useUpdateActivationWindow;
